module.exports = __webpack_public_path__ + "static/media/caixa-azul.6bc6290c.webp";